import axios from "axios";
import { apiEndpoint, apiEndpointFunction } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';

export const holidayService = {
  getHolidays,
  getUpcomingHolidays,
  getCustomHolidays,
  addCustomHoliday,
  deleteHoliday,
  checkHoliday,
};

/**
 * Get all holidays for a property and year
 * @param {number} propertyId
 * @param {number} year
 * @returns {Promise}
 */
function getHolidays(propertyId, year = new Date().getFullYear()) {
  return axios
    .get(apiEndpoint.propertyHolidays, {
      params: { property_id: propertyId, year },
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { holidays: [] };
    })
    .catch(err => {
      console.error('Error fetching holidays:', err);
      throw err;
    });
}

/**
 * Get upcoming holidays within N days
 * @param {number} propertyId
 * @param {number} days - Number of days to look ahead (default: 30)
 * @returns {Promise}
 */
function getUpcomingHolidays(propertyId, days = 30) {
  return axios
    .get(`${apiEndpoint.propertyHolidays}/upcoming`, {
      params: { property_id: propertyId, days },
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { holidays: [] };
    })
    .catch(err => {
      console.error('Error fetching upcoming holidays:', err);
      throw err;
    });
}

/**
 * Get custom holidays for a property
 * @param {number} propertyId
 * @returns {Promise}
 */
function getCustomHolidays(propertyId) {
  return axios
    .get(`${apiEndpoint.propertyHolidays}/custom`, {
      params: { property_id: propertyId },
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { holidays: [] };
    })
    .catch(err => {
      console.error('Error fetching custom holidays:', err);
      throw err;
    });
}

/**
 * Add a custom holiday
 * @param {object} data - { property_id, name, date, is_recurring }
 * @returns {Promise}
 */
function addCustomHoliday(data) {
  return axios
    .post(apiEndpoint.propertyHolidays, data, {
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error adding custom holiday:', err);
      throw err;
    });
}

/**
 * Delete a custom holiday
 * @param {number} holidayId
 * @returns {Promise}
 */
function deleteHoliday(holidayId) {
  return axios
    .delete(apiEndpointFunction.propertyHolidays(holidayId), {
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return {};
    })
    .catch(err => {
      console.error('Error deleting holiday:', err);
      throw err;
    });
}

/**
 * Check if a specific date is a holiday
 * @param {number} propertyId
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {Promise}
 */
function checkHoliday(propertyId, date) {
  return axios
    .get(`${apiEndpoint.propertyHolidays}/check`, {
      params: { property_id: propertyId, date },
      headers: authHeader()
    })
    .then(res => {
      if (res && res.status === 200) {
        return res.data;
      }
      return { is_holiday: false };
    })
    .catch(err => {
      console.error('Error checking holiday:', err);
      throw err;
    });
}
